import type { SupportedTargetLanguage } from '../enums';
import type { OriginalInput } from '../types';

export const OriginalInputService = Symbol('OriginalInputService');

export interface OriginalInputService {
    /**
     * 更新输入
     * @description 更新输入，并且：1，识别输入文本的语言；2，根据识别的输入文本的语言，设置目标语言；3，同步更新模型数据
     * @param input 输入
     */
    updateInput: (input: string) => Promise<Partial<OriginalInput>>;
    /**
     * 更新目标语言
     * @param targetLang 目标语言
     */
    updateTargetLang: (targetLang: SupportedTargetLanguage) => void;
}
